var map = {
	"./Ansar.svg": 6416,
	"./Arman.svg": 6043,
	"./Ayandeh.svg": 3016,
	"./Bank-Hekmat.svg": 6804,
	"./Bank-Markazi.svg": 7708,
	"./Day.svg": 1353,
	"./Eghtesad.svg": 6240,
	"./Gardeshgari.svg": 4768,
	"./Ghavamin.svg": 3754,
	"./Iranzamin.svg": 760,
	"./Karafarin.svg": 138,
	"./Khavarmiane.svg": 778,
	"./Kosar.svg": 241,
	"./Maskan.svg": 7904,
	"./Mehr-Eghtesad.svg": 1229,
	"./Mehr.svg": 2325,
	"./Mellat.svg": 9920,
	"./Melli.svg": 2488,
	"./Parsian.svg": 4916,
	"./Pasargad.svg": 2006,
	"./Refah.svg": 9619,
	"./Resalat.svg": 8255,
	"./Saderat.svg": 6646,
	"./Salehin.svg": 1431,
	"./Saman.svg": 3525,
	"./Samen.svg": 5247,
	"./Sanatvamadan.svg": 6549,
	"./Sarmayeh.svg": 882,
	"./Sepah.svg": 6028,
	"./Shahr.svg": 6144,
	"./Shaparak.svg": 6376,
	"./Shetab.svg": 2513,
	"./Sina.svg": 605,
	"./Tejarat.svg": 8651,
	"./Tosee-Saderat.svg": 956,
	"./Tosee-Taavon.svg": 925,
	"./Tosee.svg": 3376,
	"./keshavarzi.svg": 357,
	"./postbank.svg": 3835
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5447;